module.exports = __webpack_public_path__ + "static/media/add.dea7b697.svg";